import { useQuery, useMutation } from "@tanstack/react-query";
import { GET, POST, PUT, DELETE } from "../../../../services/index";

// รายชนิด job ที่ระบบรองรับ (สำหรับ dropdown ตอนเพิ่ม source)
export const useFetchJobTypes = () => {
  return useQuery(["systemJobTypes"], async () => {
    const { result } = await GET(`/api/v1/systemJob/job-types`);
    return result || [];
  });
};

// รายการ source ของ company ปัจจุบัน (cookie ถูกปิดจาก backend แล้ว)
export const useFetchSystemJobs = (companyId) => {
  return useQuery(
    ["systemJobs", companyId],
    async () => {
      const { result } = await GET(`/api/v1/systemJob`);
      return result || [];
    },
    { enabled: !!companyId }
  );
};

export const useCreateSystemJob = () => {
  return useMutation({
    mutationFn: async (payload) => await POST(`/api/v1/systemJob`, payload),
  });
};

export const useUpdateSystemJob = () => {
  return useMutation({
    mutationFn: async ({ id, ...payload }) => await PUT(`/api/v1/systemJob/${id}`, payload),
  });
};

export const useDeleteSystemJob = () => {
  return useMutation({
    mutationFn: async (id) => await DELETE(`/api/v1/systemJob/${id}`),
  });
};

// ยิงแจ้งเตือนทดสอบ (เช็คว่าเส้นแจ้งเตือน WebSocket ใช้งานได้)
export const useTestAlert = () => {
  return useMutation({
    mutationFn: async () => await POST(`/api/v1/systemJob/test-alert`, {}),
  });
};
